module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABXklEQVQ4T6WTvS8EURTFz3k7dtUSFYVEo/PRqdBKCImNQrEJCRGF7KwIepEI022hkSgNyRYSlcI/gKHSCAmdRKNamXlHZhLCsjsbbnnvub+c3Hce8c9ivB8cu7OwWgfZDTDp1S8J0h0Mt/qmvH1e+MX5DM3eX4xEsgsMfPceZNd3gMYgzIGcSDHzwOCoZAF8s92X3+WlXxyKlw3ggWagDkgxQLXDGBD3DVSxEdbkaJDWbILoqNU2BCRi4Q20ZVZDz+acRcJsfIWkAxKIPQltWMw6zriV8ZoHCPeR7LIjPsuo/NstGjpQGI0Yx8xInAXje/4sBn7pEUTn15GVHTY056nZEJ5447uuJXdTxb8IjFRK3v/6yF2RsAqyvSmQ9Exiuzfv7XwGSAJvK0ttr6FaPiDZTOsQIh6AyEGoIqNCjtWznsnyC4kkPykfB7g6dEdJHkgq9E97pz+C1JTlBqJ3gkug59a3GOIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/sider/sider5-2.png
// module id = 977
// module chunks = 2